export function versionBelow(current:string,minimum:string){
  const parse=(value:string)=>value.split('.').map((part)=>Number.parseInt(part,10)||0)
  const a=parse(current),b=parse(minimum)
  for(let i=0;i<3;i++){
    if((a[i]??0)<(b[i]??0))return true
    if((a[i]??0)>(b[i]??0))return false
  }
  return false
}
